import React, { useState } from 'react';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';

import NotificationsSnackbar from '../../Notifications/NotificationsSnackbar';
import ActivityFeed from '../ActivityFeed/ActivityFeed.js';
import { ToolbarProps } from '../ToolbarPropsTypes';

import AppBar from './AppBar';
import TasksDrawer from './TasksDrawers';
import { getTheme } from './Utils';

const BILLING_PLAN_TIER_LARGE = 'large';
const BILLING_PLAN_TIER_EXTRA_LARGE = 'extra large';

const LARGE_TIER_TOOLBAR_PLANS = [BILLING_PLAN_TIER_LARGE, BILLING_PLAN_TIER_EXTRA_LARGE];

const AppToolbarContainer = ({ theProps, hideNoticeBar, legacyToolbar }: ToolbarProps) => {
  const [activityFeedDrawerOpen, setActivityFeedDrawerOpen] = useState(false);
  const [tasksDrawerOpen, setTasksDrawerOpen] = useState(false);

  const toggleActivityFeedDrawer = () => setActivityFeedDrawerOpen(!activityFeedDrawerOpen);
  const toggleTasksDrawer = () => setTasksDrawerOpen(!tasksDrawerOpen);

  const largeTierToolbar = LARGE_TIER_TOOLBAR_PLANS.includes(theProps?.variant || '');

  const toolbarProps = { lightMode: largeTierToolbar, hideNoticeBar, ...theProps };

  return (
    <HousecallThemeProvider mode={getTheme(largeTierToolbar)}>
      <ActivityFeed
        isActivityFeedDrawerOpen={activityFeedDrawerOpen}
        toggleActivityFeedDrawer={toggleActivityFeedDrawer}
      />
      <TasksDrawer
        tasksDrawerOpen={tasksDrawerOpen}
        toggleTasksDrawer={toggleTasksDrawer}
        closeTasksDrawer={() => setTasksDrawerOpen(false)}
      />
      <AppBar
        toggleActivityFeedDrawer={toggleActivityFeedDrawer}
        toggleTasksDrawer={toggleTasksDrawer}
        toolbarProps={toolbarProps}
        legacyToolbar={legacyToolbar}
      />
      <NotificationsSnackbar />
    </HousecallThemeProvider>
  );
};

export default AppToolbarContainer;
